
export { CopyWalletAddress } from "/home/runner/work/play/play/src/components/core/CopyWalletAddress.tsx"